<template>
  <div class="gis-page">
    <google-map v-if="$i18n.locale==='en-US'"></google-map>
    <gaode-map v-else></gaode-map>
  </div>
</template>

<script>

import gaodeMap from "./amap.vue";
import googleMap from "./gmap.vue";
export default {
  components: {
    gaodeMap,
    googleMap
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  }
};
</script>

<style lang='less'>
.gis-page {
  width:100%;
  height: calc(100vh - 60px);
  position: relative;
}
</style>
